export enum BackgroundTaskType {
    MANUAL_DOC = 'MANUAL_DOC',
    DOC_QUEUE = 'DOC_QUEUE'
}
